import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gym-header',
  templateUrl: './gym-header.component.html',
  styleUrls: ['./gym-header.component.scss']
})
export class GymHeaderComponent implements OnInit {
  constructor() { }

  headercarousel = [
    {
      tagLine1: ' גששות בעקבות הטבע',
      tagLine2: ' ',
      description:
        'אומנות הגששות מאפשרת לנו להיכנס לזמן מה לעולמו הנסתר של בעל החיים אחריו אנו עוקבים ולהכיר אורח חיים שרובנו לא נחשפים אליו ביום יום, החיה הופכת להיות מוחשית יותר, יצור חי וייחודי עם רצונות שונים ואופי ייחודי משלו.'
    },
    {
      tagLine1: ' גששות בעקבות הטבע',
      tagLine2: ' ',
      description:
        'אומנות הגששות מאפשרת לנו להיכנס לזמן מה לעולמו הנסתר של בעל החיים אחריו אנו עוקבים ולהכיר אורח חיים שרובנו לא נחשפים אליו ביום יום, החיה הופכת להיות מוחשית יותר, יצור חי וייחודי עם רצונות שונים ואופי ייחודי משלו.'
    }
  ];

  headercarouselOptions = {
    items: 1,
    margin: 0,
    dots: false,
    center: true,
    autoWidth: true,
    nav: false,
    autoplay: false,
    slideSpeed: 300,
    paginationSpeed: 400,
    loop: true,
    mergeFit: true
  };

  ngOnInit() { }
}
